import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Box,
  CircularProgress as CircularProgressMui,
} from '@material-ui/core';

import styles from './styles';

const useStyles = makeStyles(styles);

const CircularProgress = ({ disableShrink, size, ...rest }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container} {...rest}>
      <CircularProgressMui size={size} disableShrink={disableShrink} />
    </Box>
  );
};

CircularProgress.propTypes = {
  disableShrink: PropTypes.bool,
  size: PropTypes.number,
};

CircularProgress.defaultProps = {
  disableShrink: false,
  size: 75,
};

export default CircularProgress;
